import { generateTestId } from "@client-shared";

export const setAddProductSelectionModalTestId = (identifier: string): string => generateTestId("AddProductSelectionModal", identifier);
